import React, { FC, ReactNode } from 'react';
import { ChannelConfiguration, Configuration } from 'api/notifications';
import { EventType } from 'api/notifications/meta';
import { Section } from './section';

export interface CommonProps {
  mandatory?: Mandatory[];
  configurations: Configuration[];
  onChange: (configuration: Configuration) => void;
}
export interface Mandatory {
  eventType: EventType;
  channels?: ChannelConfiguration;
}
interface GroupProps {
  group: string;
  icon: ReactNode;
}

export const Group: FC<GroupProps & CommonProps> = ({
  group,
  icon,
  mandatory,
  configurations,
  onChange,
}) => (
  <Section
    mandatory={mandatory}
    group={group}
    icon={icon}
    onChange={onChange}
    configurations={configurations}
  />
);
